import React, { useState } from 'react';
import './NavBar.scss';
import { NavLink, useLocation } from 'react-router-dom';
import SchoolIcon from '@mui/icons-material/School';

export const NavBar = () => {

    const location = useLocation();

    // El pathname actual se encuentra en location.pathname
    const currentPath = location.pathname;

    const handleLogout = () => {
        // Eliminar el ítem del localStorage al cerrar sesión
        localStorage.removeItem('userId');
        localStorage.removeItem('token');
    };

    // Estado para controlar si el menú está abierto o cerrado
    const [isMenuOpen, setIsMenuOpen] = useState(window.innerWidth > 600);

    // Función para alternar el estado del menú
    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <div className='navbar'>
            <div className='logo-div'>
                <NavLink className='navlink' to={'/home'}>
                    <div className='navbar-titulo' >
                        <img src={require('../../assets/utn-logo.png')} alt="UTN Logo"/>
                    </div>
                </NavLink>
                <div className="menu-hamburguesa" onClick={toggleMenu}>
                    <div className={`linea`}></div>
                    <div className={`linea`}></div>
                    <div className={`linea`}></div>
                </div>
            </div>
            {isMenuOpen && (
            <>
                <NavLink className='navlink' to={'/home'}>
                    <div className={`navbar-item`}>
                        <img src={require('../../assets/career.png')} alt="Mis Carreras"/>
                        <p className='title-navbar-item'>Mis carreras</p>
                    </div>
                </NavLink>
                <NavLink className='navlink' to={'/opinions'}>
                    <div className={`navbar-item`}>
                        <img src={require('../../assets/opinions.png')} alt="Opiniones"/>
                        <p className='title-navbar-item'>Opiniones</p>
                    </div>
                </NavLink>
                <NavLink className='navlink' to={'/schedule'}>
                    <div className={`navbar-item`}>
                        <img src={require('../../assets/schedule.png')} alt="Mis horarios"/>
                        <p className='title-navbar-item'>Mis horarios</p>
                    </div>
                </NavLink>
                <NavLink className='navlink' to={'/tutors'}>
                    <div className={`navbar-item`}>
                        <SchoolIcon style={{ color: '#FDFFFC', height: 25, width: 25 }}/>
                        <p className='title-navbar-item'>Tutores</p>
                    </div>
                </NavLink>
                <NavLink className='navlink' to={'/'}>
                    <div className={`navbar-item`} onClick={handleLogout}>
                        <img src={require('../../assets/logout.png')} alt="Cerrar Sesión"/>
                        <p className='title-navbar-item'>Cerrar sesión</p>
                    </div>
                </NavLink>
                <p className='suggestions'>Cualquier sugerencia envíame mensaje por instagram: <a target='_blank' href='https://www.instagram.com/mi.utn.fra'>@mi.utn.fra</a></p>
            </>
            )}
            
            <a className='cafecito' href='https://cafecito.app/miutn' rel='noopener' target='_blank'>
                <img srcset='https://cdn.cafecito.app/imgs/buttons/button_5.png 1x, https://cdn.cafecito.app/imgs/buttons/button_5_2x.png 2x, https://cdn.cafecito.app/imgs/buttons/button_5_3.75x.png 3.75x' src='https://cdn.cafecito.app/imgs/buttons/button_5.png' alt='Invitame un café en cafecito.app' />
            </a>
        </div>
    );
};
